import React, { useEffect } from "react";
import CustomAlert from "../../general/customAlert";
import { startTsPayOnboardingSession, resendOnboardingMail } from "../../../store/actions/tspay/onboarding";
import { useDispatch, useSelector } from "react-redux";
import { displaySuccessToast, displayErrorToast } from "../../../store/actions/overflowNotification";
import { FormattedMessage } from "react-intl";
import { useState } from "react";
import { GetSelectedCompanyStudio } from "../../../libs/companiesUtils";

const TsPayOnboardingToast = ({ myType, auth, itemId, onBoardingStatus, onBoardingData, isToBeConfirmedStatus }) => {
  const dispatch = useDispatch();
  const isLoadingOnboardingSession = useSelector((state) => state.tspay.isLoadingOnboardingSession.isLoading);
  const isLoadingResendOnboardingMail = useSelector((state) => state.tspay.isLoadingResendOnboardingMail.isLoading);
  const resendOnboardingMailStatus = useSelector((state) => state.tspay.isLoadingResendOnboardingMail);
  const retryOnboardingStatus = useSelector((state) => state.tspay.isLoadingOnboardingSession);
  const user = useSelector((state) => state.user);
  const [sessionUrl, setSessionUrl] = useState("");

  const studioFind = GetSelectedCompanyStudio();

  useEffect(() => {
    const onBoardingSessions = onBoardingData?.onboardingSessions;
    if (onBoardingSessions?.length > 0) {
      const mySession = onBoardingSessions?.find((u) => u.userId === user.profile.id);
      setSessionUrl(mySession?.sessionUrl);
    }
  }, [onBoardingData, user]);

  useEffect(() => {
    if (resendOnboardingMailStatus.ended && !resendOnboardingMailStatus.error) {
      dispatch(displaySuccessToast(mailSuccessMessage, ""));
    }
    if (resendOnboardingMailStatus.ended && resendOnboardingMailStatus.error) {
      dispatch(displayErrorToast(mailErrorMessage, "Errore"));
    }
  }, [resendOnboardingMailStatus]);

  useEffect(() => {
    if (retryOnboardingStatus.ended && retryOnboardingStatus.error) {
      dispatch(displayErrorToast(retryErrorMessage, "Errore"));
    }
  }, [retryOnboardingStatus]);

  const mailSuccessMessage = <FormattedMessage id="dashboard.tsPayResendOnboardingMailSuccess" />;
  const mailErrorMessage = <FormattedMessage id="dashboard.tsPayResendOnboardingMailError" />;
  const retryErrorMessage = <FormattedMessage id="dashboard.tsPayRetryErrorMessage" />;

  const manageStartSessionUrl = (res) => {
    window.open(res.data.sessionUrl, "_blank").focus();
  };

  const startOnboardingSession = () => {
    dispatch(startTsPayOnboardingSession()).then((res) => manageStartSessionUrl(res));
  };

  const resendOnboardingMailAction = () => {
    dispatch(resendOnboardingMail(auth, itemId));
  };

  const continueOnboarding = () => {
    window.open(sessionUrl, "_blank").focus();
  };

  const isStartedOnboarding = onBoardingStatus === "ONBOARDING";

  const isOnboardingSessionsEmpty = onBoardingData?.onboardingSessions.length === 0;

  if (studioFind?.taxRegion === "ES" || user?.profile?.language === "es-ES"){
    return null;
  }

  return (
    <CustomAlert
      msg1={
        isStartedOnboarding // && !isOnboardingSessionsEmpty
          ? "dashboard.tsPayOnboardingStartedMsg1"
          : isToBeConfirmedStatus
            ? "dashboard.tsPayConfirmedStatusMsg1"
            : myType === "STUDIO"
              ? "dashboard.tsPayOnBoardingMsg1Studio"
              : "dashboard.tsPayOnboardingMsg1"
      }
      msg2="dashboard.tsPayOnboardingMsg2"
      buttonText={
        isStartedOnboarding // && !isOnboardingSessionsEmpty
          ? "dashboard.buttonTextTsPayOnboardingStarted"
          : isToBeConfirmedStatus
            ? "dashboard.buttonTextTsPayConfirmedStatus"
            : "dashboard.buttonTextTsPayOnboarding"
      }
      isTsPayOnboarding={true}
      startOnboardingSession={startOnboardingSession}
      isLoadingOnboardingSession={isLoadingOnboardingSession}
      isStartedOnboarding={isStartedOnboarding}
      isOnboardingSessionsEmpty={isOnboardingSessionsEmpty}
      isToBeConfirmedStatus={isToBeConfirmedStatus}
      resendOnboardingMailAction={resendOnboardingMailAction}
      isLoadingResendOnboardingMail={isLoadingResendOnboardingMail}
      continueOnboarding={continueOnboarding}
    />
  );
};

export default TsPayOnboardingToast;
